// Import the functions you need from the SDKs you need

import { initializeApp } from 'firebase/app';

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: 'AIzaSyDdbZcXfbE-rnjvF4qk6aTxzOFJv6ShK_M',
  authDomain: 'travellyze.firebaseapp.com',
  projectId: 'travellyze',
  storageBucket: 'travellyze.appspot.com',
  messagingSenderId: '285663313902',
  appId: '1:285663313902:web:0bfbe805730df5689a58ff'

  // apiKey: 'AIzaSyCNDebPODzox5Vc15-QVNSAxvI2NSvQ-Qg',
  // authDomain: 'travellyze-test.firebaseapp.com',
  // projectId: 'travellyze-test',
  // storageBucket: 'travellyze-test.appspot.com',
  // messagingSenderId: '228643221213',
  // appId: '1:228643221213:web:4a09cebc3576bbae79f534',
  // measurementId: 'G-DW8BZ14GVC'
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const aux = initializeApp(firebaseConfig);
